import parseISO from 'date-fns/parseISO/index'
import formatDistance from 'date-fns/formatDistance/index'
import { af, arSA, be, bn, da, de, el, eo, es, fi, faIR, fr, gl, he, hu, id, is, it, ja, ko, lt, nb, nl, nn, pl, pt, ro, ru, sk, sv, th, tr, ug, uk, vi, zhCN, zhTW } from 'date-fns/locale'
//import { ar } from 'date-fns/locale/ar/index'
//import { bg } from 'date-fns/locale/bg/index'


export class DateHelper {

    _localeCode: any;
    _locales: any;

    constructor(locale: string = "en") {
        let self = this;
        
        self._locales = { af, arSA, be, bn, da, de, el, eo, es, fi, faIR, fr, gl, he, hu, id, is, it, ja, ko, lt, nb, nl, nn, pl, pt, ro, ru, sk, sv, th, tr, ug, uk, vi, zhCN, zhTW };

        self._localeCode = locale;
    }

    getDistanceInWordsToNow(datestring: any):string {
        var loc = this._locales[this._localeCode];
        if (!loc) {
            if (this._localeCode.length > 2) {
                var code = this._localeCode.substring(0, 2);
                loc = this._locales[code];
            }
        }
        if (!loc) {
            if (this._localeCode.indexOf("-") > -1) {
                var code = this._localeCode.replace('-', '');
                loc = this._locales[code];
            }
        }
        return formatDistance(parseISO(datestring), new Date(), { addSuffix: true, locale: loc });

    }
}